import { TrainingProps } from 'types/TrainingProps';

export function canSave(dataForm: TrainingProps, handleNotify: any) {
	if (dataForm.title === '') {
		handleNotify('O título é obrigatório.', 'warning');
		return false;
	}

	if (dataForm.date === '') {
		handleNotify('A data de criação é obrigatória.', 'warning');
		return false;
	}

	if (dataForm.description === '') {
		handleNotify('A descrição é obrigatória.', 'warning');
		return false;
	}

	if (dataForm.urlVideo === '') {
		handleNotify('A URL do vídeo é obrigatória.', 'warning');
		return false;
	}

	if (dataForm.content.title === '') {
		handleNotify('O título do treinamennto é obrigatório.', 'warning');
		return false;
	}

	if (dataForm.content.urlPdf === '') {
		handleNotify('A URL do PDF é obrigatória.', 'warning');
		return false;
	}

	if (dataForm.content.description === '') {
		handleNotify('Insira o conteúdo do treinamento.', 'warning');
		return false;
	}

	return true;
}
